import React, { PureComponent } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get, put } from '../../redux/modules/text';
import Image from '../../components/image/Image';
import Editor from '../../components/editor/Editor';
import * as Validations from '../../validations/validations';

const FORM_NAME = 'PartnerForm';

const Form = () => {
  return (
    <div className="form-about">
      <div className="row">
        <div className="col-xs-12">
          <label>Text</label>
          <Field
            validate={[Validations.required, Validations.minLength2]}
            name="body"
            component={Editor}/>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-4">
          <label>Image 1</label>
          <Field
            name="photo1"
            component={Image}/>
        </div>
        <div className="col-xs-4">
          <label>Image 1</label>
          <Field
            name="photo2"
            component={Image}/>
        </div>
      </div>
    </div>
  );
};

class PartnerForm extends PureComponent {

  handlerSubmit(values) {
    const { getAction, putAction, close } = this.props;
    let newData = { ...values };

    return putAction('about', newData)
      .then(() => {
        getAction('about');
        close();
      });
  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form planet-form__team"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>
        <Form/>
        <div className="clearfix"></div>
        <div className="col-lg-12 text-right form-buttons">
          <button disabled={pristine || submitting} loading={submitting} type="submit"
                  className="btn btn-primary btn-xl">Save
          </button>
          <button disabled={pristine || submitting} loading={submitting} type="button" className="btn btn-primary btn-xl"
                  onClick={reset}>Clear
          </button>
        </div>
      </form>
    );
  }
}

PartnerForm.propTypes = {};
PartnerForm.defaultProps = {};

PartnerForm = reduxForm({
  form: FORM_NAME
})(PartnerForm);

export default connect(
  (state, props) => {
    return {
      myValues: getFormValues(FORM_NAME)(state) || {},
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getAction: get,
      putAction: put
    }, dispatch);
  }
)(PartnerForm);



// WEBPACK FOOTER //
// ./src/forms/about/AboutForm.js